import {
    GET_QF_DASHBOARD_STATS_V4_STATES,
    GET_QF_DASHBOARD_STATS_V4_STATES_SUCCESS,
    GET_QF_DASHBOARD_STATS_V4_STATES_ERROR,
    GET_QF_DASHBOARD_STATS_V4_SOURCES,
    GET_QF_DASHBOARD_STATS_V4_SOURCES_SUCCESS,
    GET_QF_DASHBOARD_STATS_V4_SOURCES_ERROR,
    GET_QF_DASHBOARD_STATS_V4_CREATIVES,
    GET_QF_DASHBOARD_STATS_V4_CREATIVES_SUCCESS,
    GET_QF_DASHBOARD_STATS_V4_CREATIVES_ERROR,
    GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES,
    GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_SUCCESS,
    GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_ERROR,
    GET_QF_DASHBOARD_STATS_V4_OVERVIEW,
    GET_QF_DASHBOARD_STATS_V4_OVERVIEW_SUCCESS,
    GET_QF_DASHBOARD_STATS_V4_OVERVIEW_ERROR,
} from "./actionTypes";

// Quote Funnels - States Actions
export const getQFDashboardStatsV4States = (payload) => ({
    type: GET_QF_DASHBOARD_STATS_V4_STATES,
    payload,
});

export const getQFDashboardStatsV4StatesSuccess = (data) => ({
    type: GET_QF_DASHBOARD_STATS_V4_STATES_SUCCESS,
    payload: data,
});

export const getQFDashboardStatsV4StatesError = (error) => ({
    type: GET_QF_DASHBOARD_STATS_V4_STATES_ERROR,
    payload: error,
});

// Quote Funnels - Sources Actions
export const getQFDashboardStatsV4Sources = (payload) => ({
    type: GET_QF_DASHBOARD_STATS_V4_SOURCES,
    payload,
});

export const getQFDashboardStatsV4SourcesSuccess = (data) => ({
    type: GET_QF_DASHBOARD_STATS_V4_SOURCES_SUCCESS,
    payload: data,
});

export const getQFDashboardStatsV4SourcesError = (error) => ({
    type: GET_QF_DASHBOARD_STATS_V4_SOURCES_ERROR,
    payload: error,
});

// Quote Funnels - Creatives Actions
export const getQFDashboardStatsV4Creatives = (payload) => ({
    type: GET_QF_DASHBOARD_STATS_V4_CREATIVES,
    payload,
});

export const getQFDashboardStatsV4CreativesSuccess = (data) => ({
    type: GET_QF_DASHBOARD_STATS_V4_CREATIVES_SUCCESS,
    payload: data,
});

export const getQFDashboardStatsV4CreativesError = (error) => ({
    type: GET_QF_DASHBOARD_STATS_V4_CREATIVES_ERROR,
    payload: error,
});

// Quote Funnels - Insurance Types Actions
export const getQFDashboardStatsV4InsuranceTypes = (payload) => ({
    type: GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES,
    payload,
});

export const getQFDashboardStatsV4InsuranceTypesSuccess = (data) => ({
    type: GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_SUCCESS,
    payload: data,
});

export const getQFDashboardStatsV4InsuranceTypesError = (error) => ({
    type: GET_QF_DASHBOARD_STATS_V4_INSURANCE_TYPES_ERROR,
    payload: error,
});

// Quote Funnels - Overview Actions
export const getQFDashboardStatsV4Overview = (payload) => ({
    type: GET_QF_DASHBOARD_STATS_V4_OVERVIEW,
    payload,
});

export const getQFDashboardStatsV4OverviewSuccess = (data) => ({
    type: GET_QF_DASHBOARD_STATS_V4_OVERVIEW_SUCCESS,
    payload: data,
});

export const getQFDashboardStatsV4OverviewError = (error) => ({
    type: GET_QF_DASHBOARD_STATS_V4_OVERVIEW_ERROR,
    payload: error,
});
